<!-- Developer tools warning -->
@if (developerToolsService.emailOverride()) {
  <bolt-notification type="warning" class="mb-8">
    <b>Email Override Active</b>
  </bolt-notification>
}

<div class="w-[415px] border border-solid p-8 px-6">
  <!-- Header -->
  <div class="gap-[18px]">
    <div class="flex justify-between">
      <p class="text-vibrant-blue bolt-serif bolt-heading-sm font-bold">Quote</p>
      @if (qfStore.step() === 'QUOTE_REVIEW' && qfStore.axiomQuoteState().number) {
        <p class="text-vibrant-blue bolt-serif bolt-heading-xs">#{{ qfStore.axiomQuoteState().number }}</p>
      }
    </div>

    <p class="bolt-heading-xs">{{ currentStepTitle }}</p>

    <bolt-progress-bar [value]="qfStore.percentage()"></bolt-progress-bar>

    @if (qfStore.notificationState()?.notification) {
      <bolt-notification [type]="qfStore.notificationState()?.notification?.type" class="pt-8">
        <b>{{ qfStore.notificationState()?.notification?.title }}</b>
        <br />
        {{ qfStore.notificationState()?.notification?.message }}
      </bolt-notification>
    }
  </div>

  <!-- Step Routing -->
  <div class="pt-8">
    <ng-container *ngComponentOutlet="currentStepComponent" />
  </div>

  <hsc-confirmation-modal />
</div>
